export default "__VITE_ASSET__BfeJ43Vt__"